import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=6bd29b9d"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=6bd29b9d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports